import request from '@/utils/request'

// 商户的通知
export function shopContractReminder(data) {
    return request({
        url: '/shop/contract/shopContractReminder',
        method: 'GET',
        params: data
    })
}

